export default function Terms() {
  return (
    <div data-testid="page-terms" className="py-20 md:py-28">
      <div className="max-w-3xl mx-auto container-px">
        <p className="eyebrow">Document legal</p>
        <h1 className="h-display text-4xl md:text-5xl text-text mt-4">Termeni și condiții</h1>
        <div className="mt-10 space-y-6 text-text-soft leading-relaxed">
          <p>Acești termeni reglementează utilizarea website-ului dotapan.ro și relația comercială dintre DOTAPAN SRL și partenerii săi B2B.</p>
          <h2 className="font-display text-2xl text-text mt-8">1. Informații furnizor</h2>
          <p>DOTAPAN SRL, sediu social: Strada Parcului nr. 9, Beclean, Bistrița-Năsăud. Pentru orice detalii contractuale, ne poți contacta la dotapanromania@gmail.com sau +40 740 433 894.</p>
          <h2 className="font-display text-2xl text-text mt-8">2. Comenzi și livrare</h2>
          <p>Toate ofertele sunt personalizate pentru parteneri HoReCa, retail și distribuție. Termenele de livrare și condițiile comerciale se agreează în scris înainte de prima livrare.</p>
          <h2 className="font-display text-2xl text-text mt-8">3. Calitate</h2>
          <p>Garantăm constanța produselor în limita specificațiilor agreate. Reclamațiile se transmit în maximum 24 de ore de la recepție.</p>
          <h2 className="font-display text-2xl text-text mt-8">4. Modificări</h2>
          <p>Ne rezervăm dreptul de a actualiza acest document. Versiunea curentă este cea publicată pe site.</p>
        </div>
      </div>
    </div>
  );
}
